import message from '~/utils/message';
import i18n from '~/i18n';

import { PrinterOutlined } from '@ant-design/icons';
import { usePrintOrder } from '~/App/hooks';

const usePrintButton = (orderId: string) => {
  const { printOrderDetailReceipt } = usePrintOrder();
  const onClick = async () => {
    await printOrderDetailReceipt(orderId);
  };
  return {
    key: 'print',
    icon: <PrinterOutlined />,
    text: i18n.t('cart_print'),
    onClick,
  };
};

export default usePrintButton;
